import React, { useState, Fragment, useEffect } from 'react';
import { Card, CardBody, Button, Input, Row, Label } from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';

export default function MessengerRestricted({
  botSettings,
  saveIntegration,
  propertyId,
  isSuperAdmin,
}) {
  // const [checkedPrimarySmall, setCheckedPrimarySmall] = useState(botSettings.urlRestrictions !== null &&
  //     !botSettings.urlRestrictions.disabled
  // );
  const [inputData, setInputData] = useState({
    urlRestrictions: {
      disabled: true,
      pageLinks: '',
    },
    domainRestrictions: {
      disabled: true,
      domains: '',
    },
  });
  useEffect(() => {
    if (botSettings) {
      setInputData({
        urlRestrictions: {
          disabled: botSettings.urlRestrictions.disabled ?? true,
          pageLinks: botSettings.urlRestrictions.pageLinks ?? '',
        },
        domainRestrictions: {
          disabled: botSettings.domainRestrictions.disabled ?? true,
          domains: botSettings.domainRestrictions.domains ?? '',
        },
      });
    }
  }, [botSettings]);

  const handleUrlChange = (e) => {
    setInputData((prev) => ({
      ...prev,
      urlRestrictions: {
        ...prev.urlRestrictions,
        pageLinks: e.target.value,
      },
    }));
  };

  const handleDomainChange = (e) => {
    setInputData((prev) => ({
      ...prev,
      domainRestrictions: {
        ...prev.domainRestrictions,
        domains: e.target.value,
      },
    }));
  };

  const handleUrlSwitch = (value) => {
    setInputData((prev) => ({
      ...prev,
      urlRestrictions: {
        ...prev.urlRestrictions,
        disabled: !value,
      },
    }));
  };

  const handleDomainSwitch = (value) => {
    setInputData((prev) => ({
      ...prev,
      domainRestrictions: {
        ...prev.domainRestrictions,
        disabled: !value,
      },
    }));
  };

  const handleSave = () => {
    let setting = { ...botSettings };
    setting.urlRestrictions = {
      ...inputData.urlRestrictions,
      pageLinks: inputData.urlRestrictions.pageLinks,
    };
    setting.domainRestrictions = {
      ...inputData.domainRestrictions,
      domains: inputData.domainRestrictions.domains
        .replace(/[\n;]/g, ',')
        .split(',')
        .map((d) => d.trim())
        .filter((d) => d !== '')
        .map((d) => d.replace(/\/+$/, '').toLowerCase())
        .join(','),
    };
    saveIntegration({
      botSetting: setting,
    });
  };
  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center">
          <h6>Keep Your Web Widget Secure</h6>
        </div>
        <Separator className="mb-3" />
        <Card className="m-4">
          <Colxx md={12} className="p-4">
            <div className="d-flex w-100">
              <h6>Enable URL Restriction</h6>
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2"
                checked={!inputData.urlRestrictions.disabled}
                onChange={handleUrlSwitch}
              />
            </div>
            <Label >
              List your trusted pages <br /> Your Web Widget will only show on these pages.
            </Label>
            <div className="mb-2">
              <Input
                type="textarea"
                placeholder="https://www.example.com/page1, https://www.example.com/page2"
                value={inputData.urlRestrictions.pageLinks}
                onChange={handleUrlChange}
                name="urls"
                style={{ height: '75px' }}
              />
            </div>
            <b>
              To mark specific pages to show the Chatbot on list your trusted page, separated by commas.
            </b>
          </Colxx>
        </Card>
        {isSuperAdmin && isSuperAdmin === true && (
          <Card className="m-4">
            <Colxx md={12} className="p-4">
              <div className="d-flex w-100">
                <h6>Enable Domain Restriction</h6>
                <span
                  style={{
                    color: 'grey',
                    fontSize: '12px',
                    paddingLeft: '6px',
                  }}
                >
                  (Only visible to Super Admins)
                </span>
                <Switch
                  className="agentswitch custom-switch-primary custom-switch-small ml-2"
                  checked={!inputData.domainRestrictions.disabled}
                  onChange={handleDomainSwitch}
                />
              </div>
              <Label>
                List your trusted domains <br /> Your Web Widget will only show on these domains.
              </Label>
              <div className="mb-2">
                <Input
                  type="textarea"
                  placeholder="example.com, *.example.com"
                  value={inputData.domainRestrictions.domains}
                  onChange={handleDomainChange}
                  name="domains"
                  style={{ height: '75px' }}
                />
              </div>
              <Label>
                <b>
                  List your trusted domains and subdomains, separated by commas.
                </b>{' '}
                <br />{' '}
                To mark all your subdomains as trusted, use an asterisk as a placeholder like this: *.example.com <br />
                If you leave this field blank, your Web Widget can be added to any domain.
              </Label>
              <div
                className="p-2"
                style={{ background: '#fff8e1', border: '1px solid #ffe082' }}
              >
                <small className="text-muted">
                  ⚠ Note: This is a manual process handled by the Engineering team, and confirmation will be shared once completed.
                </small>
              </div>
            </Colxx>
          </Card>
        )}
        <Separator className="mb-3" />
        <Colxx md={12} className="text-center">
          <div className="mt-3 mb-2">
            <Button
              color="primary"
              size="xs"
              className="mt-1"
              onClick={() => handleSave()}
            >
              Save
            </Button>
          </div>
        </Colxx>
      </CardBody>
    </Card>
  );
}
